var _rect, _path, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaixa16 = function SvgFaixa16(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    fill: "#E7181F",
    stroke: "url(#paint0_linear_152_1100)",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98278 7.27273H8.2484L6.08789 8.64062V10.277L8.08647 9.02415H8.13761V16H9.98278V7.27273ZM15.4064 16.1193C17.3496 16.1278 18.6749 14.8537 18.6706 13.0767C18.6749 11.4403 17.5328 10.2599 15.986 10.2599C15.0272 10.2599 14.1792 10.7202 13.7871 11.4915H13.7275C13.736 9.79119 14.3326 8.73438 15.4703 8.73438C16.1394 8.73438 16.6209 9.10085 16.7615 9.71023H18.5811C18.4064 8.27415 17.2132 7.15341 15.4703 7.15341C13.3141 7.15341 11.9292 8.90057 11.9206 11.8324C11.9164 15.0284 13.6124 16.1108 15.4064 16.1193ZM15.3979 14.6705C14.5456 14.6705 13.915 13.9844 13.915 13.1321C13.9192 12.2841 14.5627 11.5938 15.4107 11.5938C16.263 11.5938 16.8851 12.2628 16.8809 13.1278C16.8851 14.0014 16.2502 14.6705 15.3979 14.6705Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_1100",
    x1: 1.875,
    y1: -6.39469e-7,
    x2: 24,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7181F",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaixa16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faixa_16.58840858.svg";
export { ForwardRef as ReactComponent };